import { ArticleHeading4 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { formatPhoneNumber } from '../../utils/formatPhoneNumber';

interface IPhoneNumbers {
  phones: string[];
}

export const PhoneNumbers = ({ phones }: IPhoneNumbers) => {
  return (
    <>
      {phones.map(phone => (
        <span key={phone} className={styles['phone-number']}>
          <ArticleHeading4 as="p">{formatPhoneNumber(phone)}</ArticleHeading4>
        </span>
      ))}
    </>
  );
};
